module.exports = __webpack_public_path__ + "img/upStep.b46884a6.svg";